import EmpleadoTable from "./EmpleadoTable";
import CardLayout from "../Layout/CardLayout";
import React, { useState, useEffect } from "react";
import CostoFijosTable from "./CostoFijosTable";
import PeuTable from "./PeuTable";
import Ranked from "../Ciem/Ranked";
import axiosInstance from "../../../api/api";

const Peu = (ciemId) => {
    const [rankedForm, setRankedForm] = useState([]);

    useEffect(() => {
        axiosInstance.get('/detailoption/option/value/rankedSeven').then((response) => {
            console.log("Calificación obtenida:", response.data.data[0]);
            setRankedForm(response.data.data[0]);
        }).catch((e) => {
            alert("Error consultando la calificacion " + e)
        });
    }, []);

    const contributionForm =
        <PeuTable optionName={"peuTable"}
                         ciemId={ciemId}
        />
    ;

    const calificacion = <Ranked field={rankedForm} ciemId={ciemId.ciemId} />

    return (
        <div className="container-fluid">
            <CardLayout value={"peuTitulo"} tablaComponent={contributionForm} />
            <CardLayout value={"rankedSeven"} tablaComponent={calificacion} />
        </div>
    );
};
export default Peu;